import React, {useState} from 'react';
import IconButton from '@mui/material/IconButton';
import SettingsIcon from '@mui/icons-material/Settings';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import {useNavigate} from 'react-router-dom';
import { BASE_ROUTE, BASE_ROUTE_MODULE, USER_ACCESS,UAM } from 'src/routes/BaseRoute';

const SettingsMenu: React.FC = () => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const navigate = useNavigate();

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleMenuItemClick = (path: string) => {
    navigate(path, {replace: true});
    handleClose();
  };

  return (
    <div>
      <IconButton
        aria-label="settings"
        size="large"
        sx={{marginLeft: 'auto'}}
        onClick={handleClick}>
        <SettingsIcon fontSize="inherit" />
      </IconButton>

      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        <MenuItem
          onClick={() => handleMenuItemClick(`/${BASE_ROUTE}/${UAM}`)}>
          User & Access Management
        </MenuItem>
      </Menu>
    </div>
  );
};

export default SettingsMenu;
